/**
 * Route: /plans — Story 0.2 (v2-Relaunch)
 *
 * Tarif-Uebersicht. Kanonischer Nachfolger von /premium (siehe sitemap.html
 * "Plans"). Story 6.3 ersetzt den Inhalt durch die Doppel-Limit-Preistabelle.
 *
 * Welle-2-Review F6: Die Seite bleibt CODE-GESPLITTET wie die abgeloeste
 * Premium-Route (_auth.premium.lazy.tsx). Diese Datei traegt daher nur die
 * Route-Definition; die Komponente haengt in _auth.plans.lazy.tsx und laedt
 * erst beim Navigieren nach. PlansAndApiPage zieht Stripe-/Preis-UI nach —
 * das gehoert nicht in das Haupt-Bundle jedes Seitenaufrufs.
 */
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/plans')({})
